module.exports = __webpack_public_path__ + "1793882494189/fonts/Flaticon.3d1170b.woff";